import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { computed } from 'vue';
import { useSiteConfigState, useStore } from '~/store/composable';

interface ICta {
  text: string;
  requirement: boolean;
  props: {
    target?: string;
  } & (
    | {
        // turns v-btn into a link
        href: string;
      }
    | {
        // turns v-btn into a link using vue-router (internal routes only)
        to: string;
      }
  );
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NodesHeroVideo',
  setup(__props) {

const { i18n } = useContext();
// const { state: { profile } } = useStore();
// const loggedIn = computed(() => profile.user.loggedIn);
const siteConfigState = useSiteConfigState();

const shouldShowFilmNodeBuyPage = computed(() => {
  return siteConfigState?.value?.data?.shouldShowFilmNodeBuyPage || false;
});

const ctaPrimary = computed<ICta | undefined>(() => {
  return {
    props: {
      to: `/nodes/film-node/buy`,
    },
    text: i18n.t('common.cta.buyNode').toString(),
    requirement: shouldShowFilmNodeBuyPage.value,
  };
});

const ctaSecondary = computed<ICta | undefined>(() => {
  return {
    props: {
      href: 'https://static.gala.games/gala-film/Gala%20Film_Litepaper_2023_10.pdf',
      target: '_blank',
    },
    text: i18n.t('common.cta.litepaper').toString(),
    requirement: true,
  };
});

const showCtas = computed(
  () => ctaPrimary?.value?.requirement || ctaSecondary?.value?.requirement,
);

return { __sfc: true,i18n, siteConfigState, shouldShowFilmNodeBuyPage, ctaPrimary, ctaSecondary, showCtas }
}

})